module.exports = __webpack_public_path__ + "img/thumbnail_RedPanda_m_normal.9c8f31cf.png";